<template>
<div>
    <buttons-block></buttons-block> 
    <footer>
    <div class="footer">
      <b-container class="py-2">
        <b-row>
          <b-col col cols="12" lg="4" class="text-center">
            <div class="footer-button" @click="openTelegramForm(0)">
              <div class="footer-icon">
                <b-icon icon="telephone-inbound"></b-icon>
              </div>
              Заказать обратный звонок
            </div>
            <div class="footer-button" @click="openTelegramForm(1)">
              <div class="footer-icon">
                <b-icon icon="person"></b-icon>
              </div>
              Кто мой менеджер?
            </div>
            <a href="tel:+78002010135" class="footer-button">
              <div class="footer-icon">
                <b-icon icon="telephone-outbound"></b-icon>
              </div>
              Звонок бесплатный<br />
              8 800 201 01 35
            </a>
          </b-col>
          <b-col col cols="12" lg="8" class="align-self-center">
            {{information1}}<br />
            {{information2}}<br />
            {{information3}}<br />
            {{information4}}<br /><br />
            {{copyright}} © Все права защищены
          </b-col>
        </b-row>
      </b-container>
    </div>
    <telegram-form :params="params"></telegram-form>
  </footer>
</div>  
</template>

<script>
import TelegramForm from "@/components/components/TelegramForm";
import ButtonsBlock from "@/components/components/ButtonsBlock";
import Authentication from "@/components/pages/Authentication";
export default {
  data() {
    return {
      information1:'', 
      information2:'',
      information3:'',
      information4:'',
      copyright:'',
      params: {
            firstname: null,
            lastname: null,
            patronymic: null,
            phone: null,
            prelastname: null,
            title:''
      },  
      types: [
        {
            id:1,
            firstname: null,
            lastname: null,
            patronymic: null,
            phone: null,
            prelastname: null,
            title:'Заказать обратный звонок'            
        },
        {
            id:2,
            firstname: null,
            lastname: null,
            patronymic: null,
            phone: null,
            prelastname: null,
            title:'Кто мой менеджер?',
            answers:['WhatsApp','Telegram','SMS'],
            answer:'WhatsApp',
            answercaption: 'Варианты ответа'
        },
      ],
    };
  },
  components: {
    "telegram-form": TelegramForm,
    'buttons-block':ButtonsBlock 
  },
  created() {
    this.getFooterSettings();
  },
  methods: {
    openTelegramForm(id) {    
        let self =Object.assign({}, this.types[id]);
        this.params=self;
        this.$bvModal.show('telegram-form')
    },
    async getFooterSettings() {        
      let { data } = await Authentication.sendRequestNotAuth(
        this,
        "/api/v1/getfootersettings",
        "get",
      );
      if (data) {
          data.settings.forEach(setting => {
              if(setting.key=='backcall'){
                  this.types[0].title=setting.value
              }
              if(setting.key=='whoismymanager'){
                  this.types[1].title=setting.value
              }
              if(setting.key=='answerscaption'){
                  this.types[1].answercaption=setting.value
              }
              if(setting.key=='information1'){
                  this.information1=setting.value
              }
              if(setting.key=='information2'){
                  this.information2=setting.value
              }
              if(setting.key=='information3'){
                  this.information3=setting.value
              }
              if(setting.key=='information4'){
                  this.information4=setting.value
              }
              if(setting.key=='copyrightdata'){
                  this.copyright=setting.value
              }
          });
      }
    },
  },
};
</script>

<style lang="scss">
footer {
  .footer {
    margin-top: 10px;
    font-size: 12px;
    background-color: #bbb;
    box-shadow: 1px 0 10px 5px #bbb;
    a.footer-button {
      color: #212529;
      text-decoration: none;
    }
    .footer-button {
      display: inline-block;
      vertical-align: top;
      max-width: 110px;
      padding-left: 4px;
      padding-right: 4px;  
      cursor: pointer;
      &:hover {
        .footer-icon {
          color: $hover-color;
        }
      }
    }
    .footer-icon {
      font-size: 48px;
      color: #fff;
    }
  }
}
@media (min-width: 1024px) {
  footer {
    height: 150px;
    .footer {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
    }
  }
}

@media (max-width: 1200px) {
  footer {
    height: 170px;
    .footer {
      .footer-button {
        margin-bottom: 20px;
        max-width: 90px;
      }
    }
  }
}
@media (max-width: 768px) {
  footer {
    .footer {
      .footer-button {
        max-width: 150px;
        margin: 20px;
      }
      .footer-icon {
        font-size: 60px;
      }
    }
  }
}

@media (max-width: 420px) {
  footer {
    .footer {
      .footer-button {
        display: block;
        margin: auto;
        margin-bottom: 20px;
      }
    }
  }
}
</style>